import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  IDemoStingerValues,
  LabelName,
} from '../../../../dto/demoStingerFulfilment.dto';
import {commonDateFormat} from '../../../../Service/CommonService';

type Props = {
  values: IDemoStingerValues;
};

export const truncateText = (text: string, maxLength: number) => {
  return text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

const types = [
  'GameTime Demo',
  'GT Title Sponsor Demo',
  'Neptune Radio Demo',
  'SchoolZone Demo',
  'TNN Demo',
];

const DemoStingerContent = ({values}: Props) => {
  const fields: {
    label: string;
    value: string | number | null | undefined;
  }[] = [];

  fields.push({
    label: 'Demo Stinger Fulfillment Type',
    value: types[values.request_type - 1],
  });

  fields.push({
    label: LabelName[values.request_type] ?? 'Name',
    value: values.name,
  });

  if (
    [1, 4].includes(values.request_type) &&
    values.school_name_pronunciation
  ) {
    fields.push({
      label: 'School Name Pronunciation',
      value: values.school_name_pronunciation,
    });
  }

  if (values.category) {
    fields.push({
      label: 'Category',
      value: values.category,
    });
  }

  if (values.prospect_partner) {
    fields.push({
      label: 'Prospect/Partner',
      value: values.prospect_partner,
    });
  }

  if (values.request_type === 3 && values.station_name) {
    fields.push({
      label: 'Radio Station Name',
      value: values.station_name,
    });
  }

  if ([1, 5].includes(values.request_type) && values.mascot) {
    fields.push({
      label: 'Mascot',
      value: values.mascot,
    });
  }

  if (values.request_type === 1 && values.mascot_pronunciation) {
    fields.push({
      label: 'Mascot Pronunciation',
      value: values.mascot_pronunciation,
    });
  }

  if (values.request_type === 5 && values.advertiser) {
    fields.push({
      label: 'Advertiser',
      value: values.advertiser,
    });
  }

  if (values.request_type === 5 && values.advertiser_url) {
    fields.push({
      label: 'Advertiser URL',
      value: values.advertiser_url,
    });
  }

  if (![1, 5].includes(values.request_type)) {
    fields.push({
      label: 'Standard/Rush',
      value: values.option === 1 ? 'Standard' : 'Rush',
    });
  }

  if (values.date) {
    fields.push({
      label: 'Date',
      value: commonDateFormat(values.date),
    });
  }

  // Chunk fields into rows of 4 columns
  const chunkedFields = [];
  const chunkSize = 4;
  for (let i = 0; i < fields.length; i += chunkSize) {
    chunkedFields.push(fields.slice(i, i + chunkSize));
  }

  return (
    <TableContainer>
      <Table
        sx={{
          '.MuiTableCell-root, .MuiTableRow-root': {
            border: 'none !important',
            padding: '6px 0',
          },
        }}>
        <TableBody>
          {chunkedFields.map((rowFields, rowIndex) => (
            <TableRow key={rowIndex}>
              {rowFields.map((field, fieldIndex) => (
                <TableCell key={fieldIndex}>
                  <Typography variant='subtitle1' className='text-white-50'>
                    {field.label}
                  </Typography>
                  <Tooltip title={String(field.value)}>
                    <Typography aria-label={field.label}>
                      {truncateText(String(field.value), 30)}
                    </Typography>
                  </Tooltip>
                </TableCell>
              ))}
              {rowFields.length < 4 &&
                Array.from({length: 4 - rowFields.length}).map(
                  (_, padIndex) => <TableCell key={`pad-${padIndex}`} />,
                )}
            </TableRow>
          ))}

          {values.note && (
            <TableRow>
              <TableCell className='text-white-50'>
                <Typography variant='subtitle1'>Note</Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <Typography aria-label='note'>
                  <pre style={{margin: 0, whiteSpace: 'pre-wrap'}}>
                    {values.note}
                  </pre>
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DemoStingerContent;
